import React, { useState } from 'react';
import axios from 'axios';
import './borne-kiff.css';

const IMGS = {
  veille: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/dad63211a5a391397a3174bfb33bca7c5a7c25690c516baebafd6e6e7d0b2d05.jpeg',
  modeCarte: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/f3c9ccdf95a234d5df7c9b24f74ba1b205f4ab5c1bf628e4f17744cfa18d9d93.jpeg',
  modeKiff: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/a1fd02d7305050b824ed7ac591506a14c690eb0c120cb3d76ebf45df9a01e8ea.jpeg',
  moi: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/369a0368f794526480b3ff4a8940c93a75d27e7ae4ea3773738b42f0fecd3cc6.jpeg',
  partager: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/57d7efa6a497854355e79fca865de17a349871b3bb9f72afec19f1006ad9aa21.jpeg',
  offrir: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/49af6fddaaf4230ce64c397cce4765712133c7dcab42b23c8260a0abb73c1f1f.jpeg',
  petite: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/6065672fa31c9d43cada96633352282a5cf8c90fb2763b038d01c6c6bbedd1c0.jpeg',
  jauge: 'https://static.prod-images.emergentagent.com/jobs/97058278-bf2f-431e-a9cb-46ef4e51b791/images/be5c33be56f450be96568906d491a9dd4bce544a2c1445fd2d7b9a9700719c60.jpeg',
};

export const KIFF_IMGS = IMGS;

export const KIFF_SLOTS_LABELS = [
  ['veille', 'Veille — photo géante'],
  ['modeCarte', 'Mode — La carte'],
  ['modeKiff', 'Mode — Mon Kiff'],
  ['moi', 'Occasion — Pour moi'],
  ['partager', 'Occasion — À partager'],
  ['offrir', 'Occasion — À offrir'],
  ['petite', 'Occasion — Petite envie'],
  ['jauge', 'Jauge de kiff'],
];

const OCCASIONS = [
  { id: 'moi', titre: 'Pour moi', sous: 'Mon moment à moi', teinte: '#EFE3CD' },
  { id: 'partager', titre: 'À partager', sous: 'Encore meilleur ensemble', teinte: '#F6C9C4' },
  { id: 'offrir', titre: 'À offrir', sous: 'Faire plaisir, tout simplement', teinte: '#C9D4BF' },
  { id: 'petite', titre: 'Petite envie', sous: 'Juste un petit kiff', teinte: '#F1E9D8' },
];

const eur = (v) => `${Number(v || 0).toFixed(2).replace('.', ',')} €`;

const KiffHeader = ({ etape, onRetour }) => (
  <div className="kf-head">
    {onRetour ? <button className="kf-back" onClick={onRetour} data-testid="kiff-retour">←</button> : <span className="kf-back-ph" />}
    <div className="kf-dots">{[0, 1, 2].map((i) => <span key={i} className={i <= etape ? 'on' : ''} />)}</div>
    <span className="kf-back-ph" />
  </div>
);

export const KiffFooter = ({ nbArt, total, onAllergenes, onPanier }) => (
  <div className="kf-foot" data-testid="kiff-footer">
    <span className="kf-flag">🇫🇷</span>
    <button className="kf-fbtn" onClick={onAllergenes} data-testid="kiff-foot-menu-adapte">♿<small>Menu adapté</small></button>
    <button className="kf-fbtn" onClick={onAllergenes} data-testid="kiff-foot-allergenes">ⓘ<small>Allergènes</small></button>
    <button className="kf-fbtn" data-testid="kiff-foot-aide">?<small>Besoin d'aide</small></button>
    {nbArt > 0 && <button className="kf-fpanier" onClick={onPanier} data-testid="kiff-foot-panier">🛒 {nbArt} · {eur(total)}</button>}
  </div>
);

export default function KiffFlow({ api, sid, membre, onVoirCarte, onAjouter, onOuvrir, onAllergenes, logEv, nbArt = 0, total = 0, onPanier, visuels }) {
  const IM = { ...IMGS, ...(visuels || {}) };
  const [etape, setEtape] = useState('mode');
  const [occasion, setOccasion] = useState(null);
  const [mood, setMood] = useState(50);
  const [suggs, setSuggs] = useState(null);

  const fb = (action, nom = '') => axios.post(`${api}/ai-seller/kiff/feedback`, { sid, action, nom }).catch(() => {});

  const chargerSuggestions = (occ, md) => {
    setSuggs(null);
    setEtape('sugg');
    logEv('kiff_mood', { occasion: occ, mood: md });
    axios.post(`${api}/ai-seller/kiff`, { sid, occasion: occ, mood: md, membre: !!membre })
      .then((r) => setSuggs(r.data.suggestions || []))
      .catch(() => setSuggs([]));
  };

  const voirCarte = (src) => { fb('voir_carte', src); logEv('kiff_voir_carte', { depuis: src }); onVoirCarte(); };

  return (
    <div className="kf" data-testid="kiff-flow">
      {etape === 'mode' && (
        <div className="kf-scr" data-testid="kiff-mode">
          <KiffHeader etape={0} />
          <h1 className="kf-h1">Comment tu veux commander ?</h1>
          <p className="kf-sub">Deux façons de se faire plaisir.</p>
          <div className="kf-2col">
            <button className="kf-modecard" onClick={() => voirCarte('mode_carte')} data-testid="kiff-mode-carte">
              <img src={IM.modeCarte} alt="" />
              <div className="mc-txt"><b>LA CARTE</b><small>Je sais ce que je veux</small></div>
              <span className="kf-arrow brun">→</span>
            </button>
            <button className="kf-modecard rouge" onClick={() => { logEv('kiff_mode', { choix: 'kiff' }); setEtape('occasion'); }} data-testid="kiff-mode-kiff">
              <span className="mc-sticker">GOOD<br />MOOD<br />ONLY!</span>
              <img src={IM.modeKiff} alt="" />
              <div className="mc-txt blanc"><b>MON KIFF</b><small>Aide-moi à choisir</small></div>
              <span className="kf-arrow creme">→</span>
            </button>
          </div>
        </div>
      )}

      {etape === 'occasion' && (
        <div className="kf-scr" data-testid="kiff-occasion">
          <KiffHeader etape={1} onRetour={() => setEtape('mode')} />
          <h1 className="kf-h1">Tu commandes pour quoi ?</h1>
          <p className="kf-sub">Choisis ce qui te ressemble le plus.</p>
          <div className="kf-grid2">
            {OCCASIONS.map((o) => (
              <button key={o.id} className="kf-occ" style={{ background: o.teinte }}
                onClick={() => { setOccasion(o.id); logEv('kiff_occasion', { occasion: o.id }); setEtape('jauge'); }}
                data-testid={`kiff-occ-${o.id}`}>
                <img src={IM[o.id]} alt="" />
                <b>{o.titre}</b>
                <small>{o.sous}</small>
                <span className="kf-arrow brun sm">→</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {etape === 'jauge' && (
        <div className="kf-scr" data-testid="kiff-jauge">
          <KiffHeader etape={2} onRetour={() => setEtape('occasion')} />
          <h1 className="kf-h1">Ton niveau de kiff ?</h1>
          <p className="kf-sub">Fais glisser le curseur.</p>
          <div className="kf-jauge-row">
            <div className="kf-jlabel"><span>🙂</span><b>PETITE ENVIE</b><small>Juste un truc sympa.</small></div>
            <input type="range" min="0" max="100" value={mood} onChange={(e) => setMood(Number(e.target.value))}
              className="kf-slider" style={{ '--v': `${mood}%` }} data-testid="kiff-slider" />
            <div className="kf-jlabel"><span>🤩</span><b>GROS CRAQUAGE</b><small>On se fait plaisir !</small></div>
          </div>
          <div className="kf-jimg"><img src={IM.jauge} alt="" /><span className="kf-script">MORE THAN<br />A COOKIE.</span></div>
          <button className="kf-cta" onClick={() => chargerSuggestions(occasion, mood)} data-testid="kiff-voir-suggestions">Voir nos suggestions →</button>
        </div>
      )}

      {etape === 'sugg' && (
        <div className="kf-scr" data-testid="kiff-suggestions">
          <KiffHeader etape={2} onRetour={() => setEtape('jauge')} />
          <h1 className="kf-h1">On a pensé à ça pour toi !</h1>
          <p className="kf-sub">Des produits gourmands, parfaits pour ton mood.</p>
          {!suggs ? <p className="kf-sub" style={{ marginTop: 40 }}>Une seconde, on réfléchit… 🍪</p> : (
            <div className="kf-suggs">
              {suggs.map((s, i) => (
                <div key={i} className="kf-sugg" data-testid={`kiff-sugg-${i}`}>
                  {s.badge && <span className="kf-badge">{s.badge}</span>}
                  {s.img ? <img src={s.img} alt="" /> : <div className="kf-noimg">🍪</div>}
                  <b>{s.nom}</b>
                  {s.desc && <small>{s.desc}</small>}
                  <div className="kf-sugg-bas">
                    <span>{eur(s.px)}</span>
                    <button className="kf-plus" data-testid={`kiff-sugg-add-${i}`}
                      onClick={() => { if (s.complexe) { fb('detail', s.nom); onOuvrir(s.nom); } else { fb('ajout', s.nom); logEv('kiff_sugg_ajout', { nom: s.nom }); onAjouter(s.nom, s.px); } }}>+</button>
                  </div>
                </div>
              ))}
              {suggs.length === 0 && <p className="kf-sub">Oups, rien à te proposer — va voir la carte 👇</p>}
            </div>
          )}
          <button className="kf-ghost" onClick={() => voirCarte('suggestions')} data-testid="kiff-voir-carte">Voir toute la carte →</button>
        </div>
      )}

      <KiffFooter nbArt={nbArt} total={total} onAllergenes={onAllergenes} onPanier={onPanier} />
    </div>
  );
}

export const KiffVeille = ({ onStart, visuels }) => (
  <div className="kf-veille" onClick={onStart} data-testid="borne-veille">
    <div className="kfv-head">
      <span className="kfv-labels">COOKIES<br />DRINKS<br />GOOD MOOD</span>
      <img src="/logo-boufi-brun.png" alt="boufi" />
      <span className="kfv-labels dr">AIX-EN-PROVENCE<br />EST. 2023</span>
    </div>
    <span className="kf-script kfv-slogan">MORE<br />THAN<br />A COOKIE.</span>
    <img className="kfv-img" src={(visuels || {}).veille || IMGS.veille} alt="" />
    <div className="kfv-touch" data-testid="veille-commander-btn">TOUCHE L'ÉCRAN<br />POUR COMMENCER<span className="kfv-tiret" /></div>
  </div>
);
